import { useMutation } from '@tanstack/react-query';

import { AccessKeyFormSchemaValues } from 'src/features/accessKey/utils/formSchema';
import { AccessKey } from 'src/features/accessKey/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/visitors/access-key/:id/`;

type MutationFnType = typeof mutationFn;

interface DTO extends AccessKeyFormSchemaValues {
    id: string;
    parkingId: string;
}
const mutationFn = ({ id, parkingId, ...data }: DTO): Promise<AccessKey> => {
    return axios.put(formatResourcePath(RESOURCE, { id, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateAccessKey };
